import EnvironmentManager from 'Utils/environmentManager';

export const menuList = [
  {
    title: 'İDDAA OYNA',
    iconName: 'bly-iddaa',
    list: [
      {
        content: 'İddaa',
        path: '/iddaa'
      },
      {
        content: 'Basketbol',
        path: '/iddaa/basketbol'
      },
      {
        content: 'Tenis',
        path: '/iddaa/tenis'
      },
      {
        content: 'Zirve Oran',
        path: '/iddaa/zirve-oran'
      },
      //BT-157
      {
        content: 'E-Futbol',
        path: '/iddaa/e-futbol'
      },
      {
        content: 'E-Basketbol',
        path: '/iddaa/e-basketbol'
      },
      {
        content: 'Amerikan Futbolu',
        path: '/iddaa/amerikan-futbol'
      },
      {
        content: 'Düello',
        path: '/iddaa/duello'
      },
      {
        content: 'Masa Tenisi',
        path: '/iddaa/masa-tenisi'
      },
      {
        content: 'Buz Hokeyi',
        path: '/iddaa/buz-hokeyi'
      },
      {
        content: 'MMA',
        path: '/iddaa/mma'
      },
      {
        content: 'Voleybol',
        path: '/iddaa/voleybol'
      },
      {
        content: 'Hentbol',
        path: '/iddaa/hentbol'
      },
      {
        content: 'Snooker',
        path: '/iddaa/snooker'
      }
    ]
  },
  {
    title: 'CANLI İDDAA',
    iconName: 'bly-live',
    list: [
      {
        content: 'Canlı İddaa',
        path: '/canli-iddaa'
      },
      {
        content: 'Futbol',
        path: '/canli-iddaa/futbol'
      },
      {
        content: 'Basketbol',
        path: '/canli-iddaa/basketbol'
      },
      {
        content: 'Masa Tenisi',
        path: '/canli-iddaa/masa-tenisi'
      },
      {
        content: 'Buz Hokeyi',
        path: '/canli-iddaa/buz-hokeyi'
      },
      {
        content: 'Tenis',
        path: '/canli-iddaa/tenis'
      },
      {
        content: 'Voleybol',
        path: '/canli-iddaa/voleybol'
      },
      {
        content: 'Hentbol',
        path: '/canli-iddaa/hentbol'
      },
      {
        content: 'Snooker',
        path: '/canli-iddaa/snooker'
      }
    ]
  },
  {
    title: 'AYARLAR',
    iconName: 'bly-user-settings',
    path: '/ayarlar'
  },
  {
    title: 'POPÜLER BAHİSLER',
    iconName: 'bly-fire',
    list: [
      {
        content: 'Futbol',
        path: '/iddaa/populer-bahisler'
      },
      {
        content: 'Basketbol',
        path: '/iddaa/populer-bahisler/basketbol'
      },
      {
        content: 'E-Spor',
        path: '/iddaa/populer-bahisler/e-spor'
      },
      {
        content: 'Tenis',
        path: '/iddaa/populer-bahisler/tenis'
      }
    ]
  },
  {
    title: 'KUPONLARIM',
    iconName: 'bly-user-edit',
    list: [
      {
        content: 'Devam Eden',
        path: '/kuponlarim/iddaa/devam-eden'
      },
      {
        content: 'Kazanan',
        path: '/kuponlarim/iddaa/kazanan'
      },
      {
        content: 'Kaybeden',
        path: '/kuponlarim/iddaa/kaybeden'
      },
      {
        content: 'Kayıtlı',
        path: '/kuponlarim/iddaa/kayitli'
      },
      {
        content: 'Onaylanmayan',
        path: '/kuponlarim/iddaa/onaylanmayan',
        show: EnvironmentManager.getMessageText({ key: 'rejected_coupon_tab_switch' }) === 'true'
      }
    ]
  },
  {
    title: 'CANLI MAÇ İZLE',
    iconName: 'bly-tv-tv',
    list: [
      {
        content: 'Canlı Maç İzle',
        path: '/canli-mac-izle'
      },
      {
        content: 'Canlı Futbol Maçı İzle',
        path: '/canli-mac-izle/canli-futbol-izle'
      },
      {
        content: 'Canlı Basketbol İzle',
        path: '/canli-mac-izle/canli-basketbol-izle'
      },
      {
        content: 'Canlı Tenis İzle',
        path: '/canli-mac-izle/canli-tenis-izle'
      },
      {
        content: 'Canlı Masa Tenisi İzle',
        path: '/canli-mac-izle/canli-masa-tenisi-izle'
      },
      {
        content: 'Canlı Voleybol İzle',
        path: '/canli-mac-izle/canli-voleybol-izle'
      },
      {
        content: 'Canlı E-Futbol İzle',
        path: '/canli-mac-izle/canli-e-futbol-izle'
      },
      {
        content: 'Canlı E-Basketbol İzle',
        path: '/canli-mac-izle/canli-e-basketbol-izle'
      },
      {
        content: 'Canlı Buz Hokeyi İzle',
        path: '/canli-mac-izle/canli-buz-hokeyi-izle'
      }
    ]
  },
  {
    title: 'CANLI SKOR',
    iconName: 'bly-score',
    list: [
      {
        content: 'Canlı Skor',
        path: '/canli-skor'
      },
      {
        content: 'Canlı Skor Basketbol',
        path: '/canli-skor/basketbol-canli-skor'
      }
    ]
  },
  {
    title: 'DÜNYA KUPASI NOSTALJİ',
    path: '/dunya-kupasi-nostalji',
    iconName: 'bly-world-cup-nostalgia',
    visibleKeyProps: 'world_cup_history_visible',
  },
  {
    title: 'LİG MERKEZİ',
    path: '/lig-merkezi',
    iconName: 'bly-league',
    className: 'league-resize',
    visibleKeyProps: 'league_center_toogle_on',
  },
  {
    title: 'BİLYONER BLOG',
    path: '/',
    iconName: 'bly-edit',
    visibleKeyProps: 'bilyoner_blog_footer_visible',
    linkOptions: {
      rel: 'nofollow'
    }
  },
  {
    title: 'YAZARLAR',
    path: '/yazarlar',
    iconName: 'bly-yazarlar',
  },
  {
    title: 'SPOR TOTO',
    iconName: 'bly-spor-toto',
    list: [
      {
        content: 'Spor Toto Oyna',
        path: '/spor-toto'
      },
      {
        content: 'Kuponlarım',
        path: '/spor-toto/kuponlarim'
      },
      {
        content: 'Spor Toto Sonuçları',
        path: '/spor-toto/sonuclar'
      }
    ]
  },
  {
    title: 'SAYISAL OYUNLAR',
    iconName: 'bly-mp',
    badgeNew: true,
    className: 'mp-resize',
    path: '/milli-piyango'
  },
  {
    title: 'ŞANS OYUNLARI',
    iconName: 'bly-chance-games',
    visibleKeyProps: 'digital_games_main_page_visible',
    className: 'mp-chance-games',
    list: [
      {
        content: 'Şans Oyunları',
        path: '/sans-oyunlari',
        visibleKeyProps: 'digital_games_main_page_visible',
      },
      {
        content: 'Hızlı Tombala',
        path: '/sans-oyunlari/hizli-tombala',
        visibleKeyProps: 'fastbingo_main_page_visible',
      },
      {
        content: 'Süper Tombala',
        path: '/sans-oyunlari/super-tombala',
        visibleKeyProps: 'tombala_main_page_visible',
      },
      {
        content: 'Zeplin',
        path: '/sans-oyunlari/zeplin',
        visibleKeyProps: 'zeplin_main_page_visible',
      },
      {
        content: 'Mayın Tarlası',
        path: '/sans-oyunlari/mayin-tarlasi',
        visibleKeyProps: 'mine_main_page_visible',
      },
      {
        content: 'Plinko',
        path: '/sans-oyunlari/plinko',
        visibleKeyProps: 'plinko_main_page_visible',
      },
      {
        content: 'Oyna Kazan',
        path: '/sans-oyunlari/oyna-kazan',
        visibleKeyProps: 'scratch_main_page_visible',
      },
      {
        content: 'Eşya Piyangosu',
        path: '/sans-oyunlari/esya-piyangosu',
        visibleKeyProps: 'raffle_main_page_visible',
      },
      {
        content: 'Aşağı Yukarı',
        path: '/sans-oyunlari/asagi-yukari',
        visibleKeyProps: 'dice_main_page_visible',
      },
      {
        content: 'Süper Penaltı',
        path: '/sans-oyunlari/super-penalti',
        visibleKeyProps: 'penalty_main_page_visible',
      },
      {
        content: 'Süper 10’lu',
        path: '/sans-oyunlari/super-onlu',
        visibleKeyProps: 'keno_main_page_visible',
      },
      {
        content: 'Şanslı 6',
        path: '/sans-oyunlari/sansli-alti',
        visibleKeyProps: 'luckysix_main_page_visible',
      },
      {
        content: 'Süper Çarkıfelek',
        path: '/sans-oyunlari/super-carkifelek',
        visibleKeyProps: 'spinoffortune_main_page_visible',
      },
      {
        content: 'Süper Taş Kağıt Makas',
        path: '/sans-oyunlari/super-tas-kagit-makas',
        visibleKeyProps: 'rockpaperscissors_main_page_visible',
      },
      {
        content: 'Çılgın Ninja',
        path: '/sans-oyunlari/cilgin-ninja',
        visibleKeyProps: 'ninjacrash_main_page_visible',
      },
      {
        content: 'Muhteşem Atlantis',
        path: '/sans-oyunlari/muhtesem-atlantis',
        visibleKeyProps: 'atlantis_main_page_visible',
      },
      {
        content: 'Super Yazı Tura',
        path: '/sans-oyunlari/yazi-tura-at',
        visibleKeyProps: 'coin_flip_main_page_visible',
      },
      {
        content: 'Kazanç Kulesi',
        path: '/sans-oyunlari/kazanc-kulesi',
        visibleKeyProps: 'tower_rush_main_page_visible',
      },
      {
        content: 'Altın Çark',
        path: '/sans-oyunlari/altin-cark',
        visibleKeyProps: 'golden_spin_main_page_visible',
      },
      {
        content: 'Kazandıran Balonlar',
        path: '/sans-oyunlari/kazandiran-balonlar',
        visibleKeyProps: 'winning_balloons_main_page_visible',
      },
      {
        content: 'Şanslı Eşleşme',
        path: '/sans-oyunlari/sansli-eslesme',
        visibleKeyProps: 'lucky_match_main_page_visible',
      },
      {
        content: 'Mega Balon',
        path: '/sans-oyunlari/mega-balon',
        visibleKeyProps: 'mega_baloon_main_page_visible',
      },
      {
        content: 'Büyülü Kapadokya',
        path: '/sans-oyunlari/buyulu-kapadokya',
        visibleKeyProps: 'cappadocia_main_page_visible',
      }
    ]
  },
  {
    title: 'SANAL YARIŞ',
    iconName: 'bly-virtual-race',
    visibleKeyProps: 'main_page_virtual_horse_race_visible',
    list: [
      {
        content: 'Gerçek Görüntülü At Yarışı',
        path: '/sanal-yaris/gercek-goruntulu-at-yarisi'
      },
      {
        content: 'Sanal At Yarışı',
        path: '/sanal-yaris/sanal-at-yarisi'
      },
      {
        content: 'Sanal Engel Atlama Yarışı',
        path: '/sanal-yaris/sanal-engel-atlama-yarisi'
      },
      {
        content: 'Sanal At Arabası Yarışı',
        path: '/sanal-yaris/sanal-at-arabasi-yarisi'
      },
      {
        content: 'Gerçek Görüntülü Tazı Yarışı',
        path: '/sanal-yaris/gercek-goruntulu-tazi-yarisi'
      },
      {
        content: 'Sanal Tazı Yarışı',
        path: '/sanal-yaris/sanal-tazi-yarisi'
      },
      {
        content: 'Tüm Oyunlar',
        path: '/sanal-yaris'
      },
    ]
  },
  {
    title: 'BASKAZAN',
    iconName: 'bly-tap-win',
    list: [
      {
        content: 'Büyük Mücevher Avcısı',
        path: '/bas-kazan/buyuk-mucevher-avcisi'
      },
      {
        content: ' Harika Ganimet Avcısı',
        path: '/bas-kazan/harika-ganimet-avcisi'
      },
      {
        content: 'Şans Uçağı',
        path: '/bas-kazan/sans-ucagi'
      },
      {
        content: 'Ra’nın Gizemi',
        path: '/bas-kazan/ranin-gizemi'
      },
      {
        content: 'Tüm Oyunlar',
        path: '/bas-kazan'
      },
    ],
    visibleKeyProps: 'main_page_tap_win_visible',
    badgeNew: true,
  },
  {
    title: 'TRİBÜN',
    iconName: 'bly-tribune',
    path: '/tribun'
  },
  {
    title: 'KAMPANYALAR',
    iconName: 'bly-bullhorn',
    path: '/kampanyalar'
  },
  {
    title: (EnvironmentManager.getMessageText({ key: 'reference_page_menu_title' }) || 'Bilyonpuan Festivali').toLocaleUpperCase('tr-TR'),
    iconName: 'bly-user-group-stroke',
    path: '/arkadasini-getir',
    visibleKeyProps: 'reference_page_visible'
  },
  {
    title: 'DUYURULAR',
    iconName: 'bly-comment',
    path: '/duyurular',
  },
  {
    title: "BİLYONER'İN EN'LERİ",
    iconName: 'bly-enler_icon',
    path: '/yilin-enleri',
  },
  {
    title: 'YARDIM',
    iconName: 'bly-help',
    list: []
  },
  {
    title: 'BİZE YAZIN',
    iconName: 'bly-customer-service',
    path: '/yardim/bize-yazin'
  },
  {
    title: 'ÇEREZ AYARLARI',
    iconName: 'bly-shield',
    className: 'efl-edit',
    linkOptions: {
      rel: 'nofollow'
    }
  },
  {
    title: 'SORUMLU OYUN',
    svgIconName: 'svgResponsibleGamingMenu',
    path: '/bilyoner/sorumlu-bahis'
  },
];

export const accountList = [
  {
    content: 'Kişisel Bilgilerim',
    path: '/kisisel-bilgilerim'
  },
  {
    content: 'Banka İşlemlerim',
    path: '/hesabim/banka-islemlerim'
  },
  {
    content: 'Para Çekme',
    path: '/hesabim/para-cek'
  },
  {
    content: 'Para Yatırma',
    path: '/hesabim/para-yatir'
  },
  {
    contentKey: 'pending_membership_fast_deposit_title_1',
    path: '/hesabim/hizli-para-yatir',
    visibleKeyProps: 'deposit_page_fast_deposit_switch_v2'
  },
  {
    content: 'Bilyon Kart Yükle',
    path: '/hesabim/bilyonkart'
  },
  {
    content: 'Hesap Hareketlerim',
    path: '/hesabim/hesap-hareketlerim'
  }
];
